<template>

	<div class="list-content">
		<ul class="type-gallery row row-cols-1 row-cols-sm-2 row-cols-lg-4">

			<li class="col" v-for="item in importList" :id="'item-' + item.gid">
				<a href="javascript:;" @click="goGoodsOne(item.gid)">
					<div class="thumb-box" v-if="item.thumbnail !== null" :style="'background-image:url(' + APIs.SHOP_FILE_SHOW + item.thumbIdx + ');'"></div>
					<div class="thumb-box" v-else style="background-image:url(public/ssflex/assets/hws-images/icons8-color-64.png);"></div>
					<div class="text-box">
						<div class="cate bedge-line">
							<span class="prim">{{ item.cateVO.codeName }}</span>
							<span class="sec" v-if="item.isImport">추천상품</span>
						</div>
						<h3 class="tit">{{ item.title }}</h3>
						<p class="desc">
							{{ item.contentText }}
						</p>
						<ul class="info">
							<p class="price">{{ item.basePrice | currency }} <span class="unit">원</span></p>
							<!--							<li class="auth"><span class="blind">작성자</span>{{ item.writerDec }}</li>-->
						</ul>
					</div>
				</a>
			</li>

			<li class="col" v-for="item in goodsList" :id="'item-' + item.gid">
				<a href="javascript:;" @click="goGoodsOne(item.gid)">
					<div class="thumb-box" v-if="item.thumbnail !== null" :style="'background-image:url(' + APIs.SHOP_FILE_SHOW + item.thumbIdx + ');'"></div>
					<div class="thumb-box" v-else style="background-image:url(public/ssflex/assets/hws-images/icons8-color-64.png);"></div>
					<div class="text-box">
						<div class="cate bedge-line">
							<span class="prim">{{ item.cateVO.codeName }}</span>
							<span class="sec" v-if="item.isImport">추천상품</span>
						</div>
						<h3 class="tit">{{ item.title }}</h3>
						<p class="desc">
							{{ item.contentText }}
						</p>
						<ul class="info">
							<p class="price">{{ item.basePrice | currency }} <span class="unit">원</span></p>
							<!--							<li class="auth"><span class="blind">작성자</span>{{ item.writerDec }}</li>-->
						</ul>
					</div>
				</a>
			</li>

		</ul>
	</div>

</template>

<script>
export default {
	name: "goodsList",
	props: {
		importList: Array,
		goodsList: Array,
	},
	data() {

		return {}
	},
	created() {

	},
	mounted() {

	},
	methods: {

		goGoodsOne(_idx) {
			location.href = "/app/shop/goods/" + _idx;
		}

	},
	watch: {}
}
</script>

<style scoped>

</style>
